import getSymbolFromCurrency from 'currency-symbol-map';

export function trimMoney(amount = '', currencyCode) {
  if (amount) {
    let symbol = '';
    if (currencyCode) {
      symbol = getSymbolFromCurrency(currencyCode);
    }

    const split = amount.split('.');
    if (split.length > 1) {
      const decimals = split[1].split('');
      return `${symbol + split[0]}.${decimals[0]}${decimals[1] || '0'}`;
    }

    return `${symbol + split[0]}.00`;
  }

  return amount;
}

export function truncate(string, numChars) {
  if (string && numChars && (string.length > numChars)) {
    const strToAppend = '...';
    const endCutoff = numChars - strToAppend.length;

    return `${string.substring(0, endCutoff).trim()}${strToAppend}`;
  }

  return string;
}

export function stripTrackingDetailMessage(string, carrier) {
  if (carrier !== 'USPS') return string;

  const matches = string.match(
    /^([A-Za-z]+\s+[0-9]+\s*([0-9:]+\s*[ap]m)?)\s+(.*?)(\sin\s[A-Z, ]+)?$/
  );

  return matches && matches[3] ? matches[3] : string;
}

export function camelCaseToReadable(str) {
  // http://stackoverflow.com/a/6229124/1707152
  return str
    // insert a space between lower & upper
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // space before last upper in a sequence followed by lower
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
    // uppercase the first character
    .replace(/^./, char => char.toUpperCase());
}



// WEBPACK FOOTER //
// ./utils/strings.js